(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-description"]) return;
  try {
    
  function enhanceProductDescriptions(scope) {
    scope.querySelectorAll('[data-product-description]').forEach(function(description) {
      if (description.dataset.enhanced === 'true') return;

      var image = Array.from(description.children).find(function(element) {
        return element.matches('img.mainImg');
      });
      var story = Array.from(description.children).find(function(element) {
        return element.matches('.rnbCap');
      });

      if (!image || !story) return;

      var paragraphs = Array.from(description.children).filter(function(element) {
        return element.tagName === 'P';
      });
      var designer = Array.from(description.children).find(function(element) {
        return element.matches('[data-description-designer]');
      });
      var panel = document.createElement('div');
      var details = document.createElement('div');

      panel.className = 'ever-description-panel';
      details.className = 'ever-description-details';

      paragraphs.forEach(function(paragraph) {
        var text = paragraph.textContent.trim();
        var metadata = text.match(/^(Colour|Color|Styles|Room Types)\s*:\s*(.+)$/i);

        if (metadata) {
          var label = document.createElement('span');
          var value = document.createElement('span');
          var labelText = metadata[1];

          label.className = 'ever-description-meta__label';
          value.className = 'ever-description-meta__value';
          label.textContent = labelText.charAt(0).toUpperCase() + labelText.slice(1);
          value.textContent = metadata[2];
          paragraph.className = 'ever-description-meta';
          paragraph.replaceChildren(label, value);
        } else {
          paragraph.className = 'ever-description-intro';
        }

        details.appendChild(paragraph);
      });

      if (designer) story.appendChild(designer);
      image.loading = 'lazy';
      image.decoding = 'async';
      panel.appendChild(story);
      if (details.children.length) panel.appendChild(details);
      description.replaceChildren(image, panel);
      description.classList.add('is-enhanced');
      description.dataset.enhanced = 'true';
    });
  }

  function initializeProductDescriptions() {
    enhanceProductDescriptions(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeProductDescriptions, { once: true });
  } else {
    initializeProductDescriptions();
  }

  document.addEventListener('shopify:section:load', function(event) {
    enhanceProductDescriptions(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
